import axiosInstance from '../axiosInterceptor/axiosInstance'

const deleteOrg = async (data) => {
  const { orgId } = data
  const url = `v1/orgs/${orgId}`
  return axiosInstance.delete(url)
}

export default deleteOrg
